import React from "react";

export default function MuteButton({ voiceOn, toggleVoice }) {
  return (
    <button
      onClick={toggleVoice}
      style={{ marginBottom: "10px" }}
      className="mute-button"
    >
      {voiceOn ? "🔇 Mute Hydraton" : "🔊 Unmute Hydraton"}
    </button>
  );
}
